$(function(){
    $('.navbar-toggle').click(
        function(){
        	$('body').toggleClass('no-scroll'); 
    	}
	);  
});
